<template lang="pug">
v-card
  v-toolbar(color="primary", dark, flat)
    v-toolbar-title Formulario de Contacto
  v-card-text
    ValidationObserver(
      ref="observer_form_pet_found_data",
      v-slot="{ validate, reset }"
    )
      v-form
        v-row
          v-col(cols="12", sm="12", md="6")
            ValidationProvider(
              v-slot="{ errors }",
              name="Nombre(s)",
              rules="required"
            )
              v-text-field(
                v-model="person_form.first_name",
                :error-messages="errors",
                label="Nombre(s)",
                type="text",
                clearable,
                required
              )
          v-col(cols="12", sm="12", md="6")
            ValidationProvider(
              v-slot="{ errors }",
              name="Apellido(s)",
              rules="required"
            )
              v-text-field(
                v-model="person_form.last_name",
                :error-messages="errors",
                label="Apellido(s)",
                type="text",
                clearable,
                required
              )
        v-row
          v-col(cols="12", sm="12", md="6")
            ValidationProvider(
              v-slot="{ errors }",
              name="Número de Teléfono",
              rules="required|number"
            )
              v-text-field(
                v-model="person_form.phone",
                :error-messages="errors",
                label="Número de Teléfono",
                type="number",
                clearable,
                required
              )
          v-col(cols="12", sm="12", md="6")
            ValidationProvider(
              v-slot="{ errors }",
              name="Correo Electrónico",
              rules="required|email"
            )
              v-text-field(
                v-model="person_form.email",
                :error-messages="errors",
                label="Correo Electrónico",
                type="email",
                clearable,
                required
              )
  v-card-actions
    v-spacer
    v-btn(text, color="info", @click="sendEmail") Enviar sin Formilario
    v-btn(text, color="secondary", @click="sendWithForm") Enviar con Formulario
</template>

<script>
import petAPI from "@/api/pet";
import { required, email, numeric } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío",
});

extend("numeric", {
  ...numeric,
  message: "{_field_} no admite números",
});

extend("email", {
  ...email,
  message: "Correo Electrónico debe ser válido",
});

export default {
  name: "FormPetFound",
  props: {
    pet: {
      type: Object,
      required: true,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      person: null,
      location: null,
      person_form: {
        email: null,
        phone: null,
        last_name: null,
        first_name: null,
      },
    };
  },
  methods: {
    async sendWithForm() {
      if (await this.$refs.observer_form_pet_found_data.validate()) {
        this.person = person_form;
        this.sendEmail();
      }
    },
    async sendEmail() {
      if (navigator.geolocation) {
        const geo_location = await navigator.geolocation.getCurrentPosition(
          this.getLocation
        );
      }
      const response = await petAPI.contactOwner(
        this.pet,
        this.person,
        this.location
      );
      if (response.status) {
        this.$swal({
          icon: "success",
          title: "Datos enviados",
        });
      } else {
        this.$swal({
          icon: "error",
          title: response.data,
        });
      }
    },
    getLocation(position) {
      this.location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    },
  },
};
</script>
